module.exports = new __parcel__URL__("epa-petroleum--cover.c32979a9.jpg").toString();